import {
  ExportUsersDocument,
  ExportEventsDocument,
  ExportLotUpdatesDocument,
  ExportDivisionsDocument,
  ExportHomesDocument,
  ExportBuyersDocument,
  ExportCommunitiesDocument,
  ExportLotAppointmentsDocument,
  ExportCommunityTeamMembersDocument,
  ExportHomeTeamMembersDocument,
  ExportContactsDocument,
  ExportContactTypesDocument,
  ExportPlansDocument,
  ExportDocumentsDocument,
  ExportElevationsDocument,
  ExportPhasesDocument,
  ExportDefaultPhasesDocument,
  ExportDefaultPhaseTipsDocument,
  ExportPhaseTipsDocument,
  ExportHomeDocumentsDocument,
  ExportLotAppointmentDocument,
  ExportCompaniesDocument,
  ExportReportsDocument,
  ExportConversationsDocument
} from '@tripointe/tripointe-cms/data-access';
import { ExportCollectionName } from '@tripointe/tripointe-cms/types';

export enum fileType {
  pdf = 'pdf',
  xls = 'xls'
}

export const FILE_EXTENSION = {
  [fileType.pdf]: 'pdf',
  [fileType.xls]: 'xlsx'
};

export interface ExportTypeConfig {
  visible?: boolean;
}

export const COLLECTIONS_CONFIG = {
  [ExportCollectionName.users]: {
    exportMutation: ExportUsersDocument
  },
  [ExportCollectionName.schedule]: {
    exportMutation: ExportEventsDocument
  },
  [ExportCollectionName.defaultPhaseTips]: {
    exportMutation: ExportDefaultPhaseTipsDocument
  },
  [ExportCollectionName.updates]: {
    exportMutation: ExportLotUpdatesDocument
  },
  [ExportCollectionName.divisions]: {
    exportMutation: ExportDivisionsDocument
  },
  [ExportCollectionName.homes]: {
    exportMutation: ExportHomesDocument
  },
  [ExportCollectionName.buyers]: {
    exportMutation: ExportBuyersDocument
  },
  [ExportCollectionName.communities]: {
    exportMutation: ExportCommunitiesDocument
  },
  [ExportCollectionName.homeSchedule]: {
    exportMutation: ExportLotAppointmentsDocument
  },
  [ExportCollectionName.contacts]: {
    exportMutation: ExportContactsDocument
  },
  [ExportCollectionName.contactTypes]: {
    exportMutation: ExportContactTypesDocument
  },
  [ExportCollectionName.communityContacts]: {
    exportMutation: ExportCommunityTeamMembersDocument
  },
  [ExportCollectionName.homeContacts]: {
    exportMutation: ExportHomeTeamMembersDocument
  },
  [ExportCollectionName.plans]: {
    exportMutation: ExportPlansDocument
  },
  [ExportCollectionName.documents]: {
    exportMutation: ExportDocumentsDocument
  },
  [ExportCollectionName.elevations]: {
    exportMutation: ExportElevationsDocument
  },
  [ExportCollectionName.phases]: {
    exportMutation: ExportPhasesDocument
  },
  [ExportCollectionName.defaultPhases]: {
    exportMutation: ExportDefaultPhasesDocument
  },
  [ExportCollectionName.phaseTips]: {
    exportMutation: ExportPhaseTipsDocument
  },
  [ExportCollectionName.reports]: {
    exportMutation: ExportReportsDocument
  },
  [ExportCollectionName.homeDocuments]: {
    exportMutation: ExportHomeDocumentsDocument
  },
  [ExportCollectionName.homeScheduleItem]: {
    exportMutation: ExportLotAppointmentDocument
  },
  [ExportCollectionName.vendors]: {
    exportMutation: ExportCompaniesDocument
  },
  [ExportCollectionName.conversations]: {
    exportMutation: ExportConversationsDocument
  }
};

export const DEFAULT_CONFIG_BY_TYPE: Record<fileType, ExportTypeConfig> = {
  [fileType.pdf]: {
    visible: true
  },
  [fileType.xls]: {
    visible: true
  }
};
